/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const NotFoundPage = lazyLoad(
    () => import('./index'),
    module => module.NotFoundPage,
    { fallback: <LoadingSpinner /> },
);
